
<!--<picture width="100%" height="auto">-->
<!--  <source [src]="src" type="video/mp4">-->
<!--  <source [src]="src" type="video/ogg">-->
<!--</picture>-->

<button (click)="playVideo()" class="burton-button" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);" *ngIf="!fullscreen && !playing()">Play</button>
<video *ngIf="!fullscreen" playsinline preload="metadata" #video width="100%" height="auto" [src]="src" (ended)="videoEnded()" (play)="startedPlaying()">
  <source [src]="src" type="video/mp4">
  Your browser does not support the video tag.
</video>

<video *ngIf="fullscreen" #video width="100%" preload="metadata" height="auto" [src]="src" (ended)="videoEnded()" controls >
  <source [src]="src" type="video/mp4">
  Your browser does not support the video tag.
</video>
